import { graphql } from 'react-relay';

export const gqlEditMercariItem = graphql`
  mutation editMercariItemMutation($itemId: String!, $sizeId: MercariIntPutObject) {
    mercariEditMercariItem(itemId: $itemId, sizeId: $sizeId) {
      success
    }
  }
`;
